import React, { useEffect, useRef, useState } from "react";

const otpCss = {
  width: "45px",
  height: "45px",
  margin: "8px",
  textAlign: "center",
  fontSize: "1.2em",
};

const Otp = ({ length, onSubmit }) => {
  const inputRef = useRef([]);
  //const [otp, setOtp] = useState('');
  const [value, setValue] = useState(new Array(length).fill(""));

	 const onChangeHandler = (e, index) => {
	  const inputValue = e.target.value;

	  // Allow only digits
	  if (!/^\d*$/.test(inputValue)) return;

	  const newValue = [...value];

	  // Take only last digit (handles paste)
	  newValue[index] = inputValue.slice(-1);
	  setValue(newValue);

	  // Move focus to next input
	  if (inputValue && index < length - 1) {
		inputRef.current[index + 1]?.focus();
	  }

	  const finalValue = newValue.join("");

	  // Submit only when OTP is complete
	  if (finalValue.length === length) {
		onSubmit(finalValue);
	  }
	};

	const onClickHandler = (index) => {
	const input = inputRef.current[index];
	if (!input) return;

	const length = input.value.length;
	input.setSelectionRange(length, length);
	};

	const onKeyDownHandler = (e, index) => {
	  if (e.key === "Backspace") {
		// If current box is empty, move focus back
		if (!value[index] && index > 0) {
		  inputRef.current[index - 1]?.focus();
		}

		// Clear current value explicitly
		const newValue = [...value];
		newValue[index] = "";
		setValue(newValue);
	  }
	};


  useEffect(() => {
    if (inputRef.current[0]) inputRef.current[0].focus();
  }, []);
  
  /*  useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;

        const readSmsOtp = async () => {
          if ('OTPCredential' in window) {
            try {
              const content = await navigator.credentials.get({
                otp: { transport: ['sms'] },
                signal: signal,
              });
              if (content && content.code) {
                setOtp(content.code);
              }
            } catch (err) {
              console.error('Error reading OTP:', err);
            }
          }
        };

        readSmsOtp();

        return () => {
          abortController.abort(); // Clean up on unmount
        };
      }, []); */

  return (
    <div>
      <form>
		 {value.map((item, index) => (
		  <input
			key={index}
			ref={(input) => (inputRef.current[index] = input)}
			value={item}
			style={otpCss}
			className="otp_input"
			type="text"
			inputMode="numeric"
			pattern="[0-9]*"
			autoComplete="one-time-code"
			maxLength={1}
			placeholder="0"
			onChange={(e) => onChangeHandler(e, index)}
			onClick={() => onClickHandler(index)}
			onKeyDown={(e) => onKeyDownHandler(e, index)}
		  />
		))}
      </form>
    </div>
  );
};
export default Otp;